import ShopDirectionIcon from '@/components/icons/shop/DirectionIcon';
import { MarkerIcon } from '@/components/icons';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';

interface HotplaceDetailActionsProps {
    onLocationClick: () => void;
    onDirectionClick: () => void;
    tabIndexBase?: number;
    locationRegionOrder?: number;
    directionRegionOrder?: number;
}

const HotplaceDetailActions = ({
    onLocationClick,
    onDirectionClick,
    tabIndexBase = 5,
    locationRegionOrder = 5,
    directionRegionOrder = 6,
}: HotplaceDetailActionsProps) => {
    const { t } = useTranslation();

    return (
        <div className={styles.actions}>
            <button
                type="button"
                className={clsx(styles['actions__btn'], 'focus-border', styles['actions__btn--location'])}
                onClick={onLocationClick}
                tabIndex={tabIndexBase}
                data-interactive
                aria-label={t('common.button.location_confirmation')}
                data-role={t('common.data_role.button')}
                data-region-nav
                data-region-order={locationRegionOrder}
            >
                <MarkerIcon width={28} height={28} />
                {t('common.button.location_confirmation')}
            </button>

            <button
                type="button"
                className={clsx(styles['actions__btn'], 'focus-border', styles['actions__btn--direction'])}
                onClick={onDirectionClick}
                tabIndex={tabIndexBase + 1}
                data-interactive
                aria-label={t('common.button.direction')}
                data-role={t('common.data_role.button')}
                data-region-nav
                data-region-order={directionRegionOrder}
            >
                <ShopDirectionIcon width={28} height={28} />
                {t('common.button.direction')}
            </button>
        </div>
    );
};

export default HotplaceDetailActions;
